<template
>
  <div
    v-if="sizeOptionKey"
    class="product-item__sizes"
    @click="toggleSwatches"
  >
    <p class="body-small">
      {{ sizesTitle }}
    </p>
    <ul class="product-item__sizes-list">
      <li
        v-for="(size, index) in sizes"
        v-if="sizes.length"
        :key="index"
      >
        <a
          :class="getSizeClasses(size)"
          @click="(event) => addToCart(size, event)"
          :disabled="!getSizeClasses(size)"
        >
          {{ size }}
        </a>
      </li>
      <li
        v-if="!sizes.length"
        :key="0"
      >
        <a
          :class="getSizeClasses('One Size')"
          @click="(event) => addToCart('One Size', event)"
          :disabled="!getSizeClasses('One Size')"
        >
          One Size
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    contextUrl: String,

    sizes: {
      type: Array,
      required: true,
    },

    sizeOptionKey: {
      type: String,
      required: true,
    },

    variants: {
      type: Array,
      required: true,
    },

    product: {
      type: Object,
      required: true,
    },

    toggleSwatches: {
      type: Function,
    }
  },

  computed: {
    sizesTitle() {
      return window.theme.strings.products.product.sizesAvailable;
    },
  },

  methods: {
    getContextUrl() {
      return this.contextUrl.split('/products')[0];
    },

    getFirstVariantWithSize(size) {
     return this.variants.find((variant) => variant[this.sizeOptionKey] === size);
    },

    async addToCart(size, event) {
      if (event.target.className === 'disabled'){
        return
      }



        let $this = this;
        let extraProperties = {};

        let firstVariantWithSize = {}
        
        if (size === 'One Size') {
          firstVariantWithSize = this.variants[0]
        } else {
          firstVariantWithSize = $this.getFirstVariantWithSize(size);
        }

        await this.sendDataLayer('quickview_add_to_cart', firstVariantWithSize);

        setTimeout(function(){
          document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
              quantity: 1
            }
          }));
        }, 500);

          document.documentElement.dispatchEvent(new CustomEvent('flu:quick-cart:open', {
          bubbles: true,
          detail: {
              quantity: 1
            }
          }));

        const cart = document.querySelector('.cart-flyout');
        const drawerOverlay = document.querySelector('.drawer-overlay');
        const drawerOverlayInner = document.querySelector('.drawer-overlay__inner');

        cart.classList.add('is-visible');
        drawerOverlay.classList.add('is-active');
        drawerOverlayInner.classList.add('is-visible');
        
        await $this.$store.dispatch('cart/addItem', {
          quantity: 1,
          id: firstVariantWithSize.id,
          properties: extraProperties,
        });

      },

      sendDataLayer(event, firstVariantWithSize) {

        let data = [
          {
            name: this.product.title.replace("'", ''),
            variantId: (firstVariantWithSize.id && firstVariantWithSize.sku) || '',
            productId: this.product.id,
            price: firstVariantWithSize.price,
            brand: this.product.vendor.replace("'", ''),
            position: this.position || '',
            category: this.collection || '',
            list: this.collectionHandle || '',
            handle: this.product.handle,
          },
        ];

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': event,
          'products': data,
        });
      },

    /**
     * We return the 'disabled' class if the variant is unavailable. There could be N variants with a specific size, so we need to
     * find all the variants having that specific size and then compare them all to check if every one of them is sold out or not
     */
    getSizeClasses(size) {
      let variantsWithSize = {}
      let sizeIsAvailable = false;
        if (size === 'One Size') {
          variantsWithSize = this.variants[0]
          sizeIsAvailable = variantsWithSize.available;
        } else {
          variantsWithSize = this.variants.filter((variant) => variant[this.sizeOptionKey] === size);
          sizeIsAvailable = variantsWithSize.some((variant) => variant.available);
        }       
      return {
        disabled: !sizeIsAvailable,
      };
    },

    // There could be N variants with a specific size, so we select the first one
    getVariantUrl(size) {
      const firstVariantWithSize = this.getFirstVariantWithSize(size);
      return `${this.getContextUrl()}${firstVariantWithSize.url}`;
    },
  },
}
</script>

<style>

</style>